import { render } from "./ChatbotElement.vue?vue&type=template&id=01bdfd18&scoped=true"
import script from "./ChatbotElement.vue?vue&type=script&lang=js"
export * from "./ChatbotElement.vue?vue&type=script&lang=js"

import "./ChatbotElement.vue?vue&type=style&index=0&id=01bdfd18&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/components/elements/chatbot-element.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FChatbotElement.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bdfd18"]])

export default __exports__